var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "poi-tag hot-click-area",
    on: {
      "click": _vm.handelClick
    }
  }, [_vm.leftIcon ? _c('div', {
    staticClass: "left-icon",
    style: {
      'background-image': `url(${_vm.leftIcon})`
    }
  }) : _vm._e(), _c('div', {
    staticClass: "poi-name"
  }, [_vm._t("default")], 2), _vm.showRightIcon ? _c('div', {
    staticClass: "arrow-icon"
  }) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };